import {createStore, applyMiddleware} from 'redux'
import thunk from 'redux-thunk'
import createLogger from 'redux-logger'
import R from 'ramda'

import reducer from './reducer'

const milddlewares = (process.env.NODE_ENV == "production") ? [thunk] : [thunk, createLogger({collapsed:true})]
const appliedMidleware = R.apply(applyMiddleware, milddlewares)
export default createStore(reducer, appliedMidleware)



/** WEBPACK FOOTER **
 ** ./app/store.js
 **/